import { Select } from '@mantine/core';

import { useContentCategoryOptions } from '../hooks/useContentCategoryOptions';

type Props = {
  pageId: string | null;
  value: string | null;
  onChange: (value: string | null) => void;
};

export const CategoryFilter = ({ pageId, value, onChange }: Props) => {
  const categoryOptions = useContentCategoryOptions(pageId);

  return (
    <Select
      value={value ?? ''}
      onChange={(next) => onChange(next || null)}
      data={[{ value: '', label: 'Все категории' }, ...categoryOptions]}
      allowDeselect={false}
      searchable
      w={220}
      placeholder="Все категории"
      nothingFoundMessage="Нет категории"
    />
  );
};
